import { render, staticRenderFns } from "./FactoryDetails.vue?vue&type=template&id=20a0fefb&scoped=true&"
import script from "./FactoryDetails.vue?vue&type=script&lang=js&"
export * from "./FactoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./FactoryDetails.vue?vue&type=style&index=0&id=20a0fefb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a0fefb",
  null
  
)

export default component.exports